import React, { useState } from 'react';
import { validateFunctionalForm } from '../../../utils';
import { v2_schedule_categories } from '../../../actions/v2/masterData';
import constant from '../../../constant';

const EventForm = ({ data, onSubmit }) => {
    const [state, setState] = useState({
        eventName: { name: 'eventName', value: data?.NAME || '', isRequired: true, error: '' },
        categoryId: { name: 'categoryId', value: data?.CATEGORY_ID || '', options: [], isRequired: true, error: '' },
        remark: { name: 'remark', value: data?.DESCRIPTION || '', isRequired: false, error: '' },
        colorCode: { name: 'colorCode', value: data?.COLOR_CODE || '#000000', isRequired: true, error: '' }

    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const val = type === 'checkbox' ? checked : value;

        setState(prev => ({
            ...prev,
            [name]: {
                ...prev[name],
                value: val,
                error: prev[name].isRequired && !val ? 'This field is required' : ''
            }
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateFunctionalForm(state, setState)) {
            const model = {};
            Object.keys(state).forEach(key => {
                model[key] = state[key].value;
            });
            if (data?.ID) model.id = data.ID;
            onSubmit(model);
        }
    };

    const handleReset = () => {
        const resetState = { ...state };
        Object.keys(resetState).forEach(key => {
            resetState[key].value = data?.[key.toUpperCase()] || (key === 'isActive' ? true : '');
            resetState[key].error = '';
        });
        setState(resetState);
    };


    useState(() => {
        v2_schedule_categories().then((res) => {
            if (res.status) {
                setState(prev => ({
                    ...prev,
                    ['categoryId']: {
                        ...prev['categoryId'],
                        options: res.result
                    }
                }));
            }
        })
    }, [])
    return (
        <form onSubmit={handleSubmit}>
            <div className="row">
                <div className="col-md-4 mb-3">
                    <label>Event Name {state.eventName.isRequired && <span className='text-danger'> *</span>}</label>
                    <input
                        type="text"
                        name={state.eventName.name}
                        value={state.eventName.value}
                        onChange={handleChange}
                        placeholder="Enter event type"
                        className={`form-control ${state.eventName.error ? 'is-invalid' : ''}`}
                    />
                    {state.eventName.error && <div className="invalid-feedback">{state.eventName.error}</div>}
                </div>

                <div className="col-md-4 mb-3">
                    <label>Category {state.categoryId.isRequired && <span className='text-danger'> *</span>}</label>
                    <select
                        name={state.categoryId.name}
                        value={state.categoryId.value}
                        onChange={handleChange}
                        className={`form-control ${state.categoryId.error ? 'is-invalid' : ''}`}
                    >
                        <option value="">Select category</option>
                        {state.categoryId.options?.map((opt) => (
                            <option key={opt.ID} value={opt.ID}>
                                {opt.CATEGORY_NAME}
                            </option>
                        ))}
                    </select>
                    {state.categoryId.error && <div className="invalid-feedback">{state.categoryId.error}</div>}
                </div>
                <div className="col-md-4 mb-3">
                    <label>Color Code {state.colorCode.isRequired && <span className='text-danger'> *</span>}</label>
                    <input
                        type="color"
                        name={state.colorCode.name}
                        value={state.colorCode.value}
                        onChange={handleChange}
                        className={`form-control form-control-color ${state.colorCode.error ? 'is-invalid' : ''}`}
                        title="Choose your color"
                    />
                    {state.colorCode.error && <div className="invalid-feedback">{state.colorCode.error}</div>}
                </div>

                <div className="col-md-12 mb-3">
                    <label>Description</label>
                    <textarea
                        name={state.remark.name}
                        value={state.remark.value}
                        onChange={handleChange}
                        className="form-control"
                        rows="2"
                        placeholder="Any additional notes"
                    />
                </div>


            </div>

            <div className="mt-3">
                <button type="submit" className="btn btn-success me-2">Save</button>
                <a className="btn btn-danger text-white"  href={constant.Authedcomponent.listCategoryEventMasterData.url}>Cancel</a>

            </div>
        </form>
    );
};

export default EventForm;
